module.exports = __webpack_public_path__ + "img/triangle.320c086e.svg";